// extracted by mini-css-extract-plugin
export default {"modal":"g23D1qawhwyio4dK_YwQ","body":"YDUgKdDERgXPqELF4Atv","cta":"Z1z_ZBxIMvvdmJij_99k"};